import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { APP_ICONS } from '../../../../static/appIcons.js';
import { NAVIGATION_PATHS } from '../../../../static/navigationPaths.js';

const TitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    let pageName = '';

    const locationSegments = location.pathname.split('/');
    const currentPageLocation = locationSegments.length > 3
      ? locationSegments.pop()
      : '';

    switch (currentPageLocation) {
      case NAVIGATION_PATHS.HOME:
        pageName = 'Home';
        break;
      case NAVIGATION_PATHS.BUDGET_SUMMARY:
        pageName = APP_ICONS.BUDGET_SUMMARY;
        break;
      case NAVIGATION_PATHS.BUDGET_LINE_ITEM_EDITOR:
        pageName = APP_ICONS.BUDGET_LINE_ITEM_EDITOR;
        break;
      case NAVIGATION_PATHS.PROGRAM_INVENTORY:
        pageName = APP_ICONS.PROGRAM_INVENTORY;
        break;
      case NAVIGATION_PATHS.COST_ALLOCATION:
        pageName = APP_ICONS.COST_ALLOCATION;
        break;
      case NAVIGATION_PATHS.DEPARTMENT_SCORING:
        pageName = APP_ICONS.DEPARTMENT_SCORING;
        break;
      case NAVIGATION_PATHS.DEPARTMENT_REVIEW:
        pageName = APP_ICONS.DEPARTMENT_REVIEW;
        break;
      case NAVIGATION_PATHS.PEER_REVIEW:
        pageName = APP_ICONS.PEER_REVIEW;
        break;
      case NAVIGATION_PATHS.FINAL_REVIEW:
        pageName = APP_ICONS.FINAL_REVIEW;
        break;
      case NAVIGATION_PATHS.DATA_VISUALIZATIONS:
        pageName = APP_ICONS.DATA_VISUALIZATION;
        break;
      case NAVIGATION_PATHS.PROGRAM_INSIGHTS:
        pageName = APP_ICONS.PROGRAM_INSIGHTS;
        break;
      case NAVIGATION_PATHS.BUDGET_REQUESTS:
        pageName = APP_ICONS.BUDGET_REQUESTS;
        break;
      case NAVIGATION_PATHS.REPORTS:
        pageName = APP_ICONS.REPORTS;
        break;
      case NAVIGATION_PATHS.ORGANIZATIONAL_HIERARCHY:
        pageName = APP_ICONS.ORGANIZATIONAL_HIERARCHY;
        break;
      case NAVIGATION_PATHS.NAME_CONVENTION:
        pageName = APP_ICONS.NAME_CONVENTIONS;
        break;
      case NAVIGATION_PATHS.MANAGE_USERS:
        pageName = APP_ICONS.MANAGE_USERS;
        break;
      case NAVIGATION_PATHS.MANAGE_USER_ACCESS:
        pageName = APP_ICONS.MANAGE_USER_ACCESS;
        break;
      case NAVIGATION_PATHS.USER_ACTIVITY:
        pageName = APP_ICONS.USER_ACTIVITY;
        break;
      case NAVIGATION_PATHS.CONFIGURE_BUDGET:
        pageName = APP_ICONS.CONFIGURE_BUDGET;
        break;
      case NAVIGATION_PATHS.CONFIGURE_SCORING:
        pageName = APP_ICONS.CONFIGURE_SCORING;
        break;
      case NAVIGATION_PATHS.CONFIGURE_INSIGHTS:
        pageName = APP_ICONS.CONFIGURE_INSIGHTS;
        break;
      case NAVIGATION_PATHS.CONFIGURE_REQUESTS:
        pageName = APP_ICONS.CONFIGURE_REQUESTS;
        break;
      case NAVIGATION_PATHS.ORGANIZATION_EDITOR:
        pageName = APP_ICONS.ORGANIZATION_EDITOR;
        break;
      case NAVIGATION_PATHS.MANAGE_ADMIN_USERS:
        pageName = APP_ICONS.MANAGE_ADMIN_USERS;
        break;
      case NAVIGATION_PATHS.MANAGE_ORGANIZATION_ACCESS:
        pageName = APP_ICONS.MANAGE_ORGANIZATION_ACCESS;
        break;
      case NAVIGATION_PATHS.MANAGE_DATA:
        pageName = APP_ICONS.MANAGE_DATA;
        break;
      case NAVIGATION_PATHS.PBB_STRATEGIST:
        pageName = APP_ICONS.PBB_STRATEGIST;
        break;
      case NAVIGATION_PATHS.COST_BENCHMARK:
        pageName = APP_ICONS.COST_BENCHMARK;
        break;
      case NAVIGATION_PATHS.AI_ANALYTICS:
        pageName = APP_ICONS.AI_ANALYTICS;
        break;
      case NAVIGATION_PATHS.USER_PROFILE:
        pageName = 'User profile';
        break;
      case NAVIGATION_PATHS.SESSION_TIMEOUT:
        pageName = 'Session Timeout';
        break;
      case NAVIGATION_PATHS.LOGIN:
        pageName = 'Login';
        break;
      default:
        pageName = '';
    }

    document.title = `${pageName} | Priority Based Budgeting`;
  }, [location.pathname]);

  return null;
};

export default TitleUpdater;
